import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import moment from 'moment';
import {CONFIG_ENV} from '@/config';
import {humanReadableBytes} from '@/modules/utils';
import nomenclatoare from '@/store/nomenclatoare';
import iDocumentIntrare from '@/types/iDocumentIntrare';
import iScan from '@/types/iScan';
import {dateToStringDDMonYYYY} from '@/modules/utils';
import {ServicesDocument} from '@/modules/ServicesDocument';
import {ServicesScans} from '@/modules/ServicesScans';
type OrNull<T> = { [K in keyof T]: T[K] | null }

@Component({components: {}})
export default // @ts-ignore
// @ts-ignore
class DialogOpenScan extends Vue {
  @Prop({ default: '0' }) readonly appid!: string;
  public loadingInfoScan:boolean = false;
  public myLocale:any;
  public $refs: any;
  public uploadingFileToServer:boolean=false;
  public uploadScanTitle: string  = '';
  public urlForUpload:string = '';
  public headers:any= { 'access-token': '<your-token>' };
  private storeNomenclatoare = getModule(nomenclatoare);
  public filesSelectedForUpload:any= [];
  public scan: iScan;
  // private userStore=getModule(User);

  constructor() {
    super();
    this.myLocale=CONFIG_ENV.myLocale;
    this.urlForUpload=CONFIG_ENV.URL_SCAN.uploadScan;
    this.scan={
      appid: 0,
      file_name: '',
      description: '',
      file_size: 0,
      file_ext: '',
      track_date: '',
      track_user: '',
      id_doc: 0
    }
  }


  public getInfoScan(){
    const vueInst=this;
    vueInst.loadingInfoScan=true;
    ServicesScans.getInfoScan(Number(vueInst.appid)).then((presponse)=>{
      vueInst.loadingInfoScan=false;
      if(presponse.status==='success'){
        vueInst.scan=JSON.parse(JSON.stringify(presponse.scan));
      }
    });
  }


  public displayDataDoc() :string{
    const vueInst=this;
    if(vueInst.scan.track_date){
      const day =moment(vueInst.scan.track_date.substr(0,10), "YYYY-MM-DD");
      return dateToStringDDMonYYYY(day);
    }else { return '';}
  }


  public humanReadableBytes(nrPfBytes:number): string{
    return humanReadableBytes(nrPfBytes);
  }


  public openPreviewForm(pappid: number){
    const vueInst = this;
    //@ts-ignore;
    vueInst.$eventHub.$emit('eventFromChildComponent',{action:'show_preview_file',scan_appid:pappid});
  }

  @Watch('appid', { immediate: true })
  onAppidChanged(newVal: string, oldVal: string) {
    const vueInst = this;
    vueInst.loadingInfoScan=true;
    if(Number(newVal) !=0 && Number(vueInst.appid) != 0) {
      vueInst.getInfoScan();
    }
  }
}
